// extracted by mini-css-extract-plugin
export default {"tblheader":"SearchQuestion_tblheader__0zvUP"};